import { render, staticRenderFns } from "./SettingsChrome.vue?vue&type=template&id=640f6ad8&"
import script from "./SettingsChrome.vue?vue&type=script&lang=js&"
export * from "./SettingsChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports